'use strict';

const { fetchCategorySliderBids } = require('./adformBidsRequest');
const adformConstants = require('./adformConstants');
const { addAdformPlaceholder, initAdformRequestLifecycle } = require('./common/adformHelperFunctions');
const { buildBidSlides, insertBidSlides, revealSlider } = require('./helpers/adformSliderSlideHelpers');

const CATEGORY_CONTAINER_CONFIGS = [
    adformConstants.CONTAINER_TYPE_CATEGORY_CONFIG,
    adformConstants.CONTAINER_TYPE_SUB_CATEGORY_CONFIG
];

let slider = null;
let bids = null;

/**
 * Inserts bids (if any) into the slider and reveals it.
 * Only runs once both the slider element and the adform response are known - whichever arrives second,
 * since the request is fired from <head> (may finish before the slider even exists in the DOM),
 * while the "ready" event fires once the slider markup has been parsed (which may happen first instead).
 */
function finalize() {
    if (!slider || bids === null) {
        return;
    }

    const slides = buildBidSlides(bids);
    const isSlideInserted = insertBidSlides(slider, slides);
    if (isSlideInserted) {
        // no adjustSlideTrackingIndexes() here on purpose - unlike the homepage slider,
        // this slider's slide-click tracking is not meant to include ad slides
        const sliderWrapper = slider.closest('.js-global-swiper-slider');
        if (sliderWrapper?.classList.contains('d-none')) {
            sliderWrapper.classList.remove('d-none');
        }
    }
    revealSlider(slider);

    slider = null;
    bids = null;
}

/**
 * Init events that make adform request to get data to create banner ads for the category/sub-category banner slider.
 */
function initMakeRequestEvents() {
    if (window.shouldFetchAdformCategoryBids) {
        fetchCategorySliderBids(adformConstants.CONTAINER_TYPE_CATEGORY_CONFIG);
    }

    if (window.shouldFetchAdformSubCategoryBids) {
        fetchCategorySliderBids(adformConstants.CONTAINER_TYPE_SUB_CATEGORY_CONFIG);
    }

    document.addEventListener('isml:categoryBannerSlider:ready', (e) => {
        slider = e.detail?.slider;
        if (!slider) {
            return;
        }

        addAdformPlaceholder(slider);
        finalize();
    });
}

/**
 * Init events that wait for adform response to get processed:
 * - case bids exist => insert ad slides, reveal slider
 * - case no bids => just reveal slider (nothing was ever reserved, so there's nothing to remove)
 */
function initResponseHandlingEvents() {
    document.addEventListener(adformConstants.BIDS_READY_CUSTOM_EVENT_NAME, function (e) {
        if (!CATEGORY_CONTAINER_CONFIGS.includes(e.detail?.containerTypeConfig)) {
            return;
        }

        bids = e.detail?.bids || [];
        finalize();
    });

    document.addEventListener(adformConstants.NO_BIDS_CUSTOM_EVENT_NAME, function (e) {
        if (!CATEGORY_CONTAINER_CONFIGS.includes(e.detail?.containerTypeConfig)) {
            return;
        }

        bids = [];
        finalize();
    });
}

module.exports = {
    init: function () {
        initAdformRequestLifecycle(initResponseHandlingEvents, initMakeRequestEvents);
    }
};
